// T2899: prvi uvoz — lovilec zgodnjih napak, preden se izvede ostala koda.
import './lib/sentryEarly'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import { ToastProvider } from './components/ui/ToastProvider'
import './index.css'
import i18n, { i18nReady } from './i18n'
import { prevajalnikApiNapakIzI18n, setDefaultApiErrorTranslator } from './lib/apiError'
import { scheduleSentryStart } from './lib/sentryLazy'
import { captureImportHandoff } from './lib/importHandoff'

// T3077: žeton predaje popisa s spletne strani (`/register#uvoz=<žeton>`) se
// zajame PRED nastankom usmerjevalnika. `App.tsx` prijavljenega uporabnika z
// `/register` preusmeri na `/dashboard` in fragment bi se s tem izgubil.
captureImportHandoff()

// T1414: strojna koda odziva se odslej prevede povsod, ne le na šestih zaslonih,
// ki so `translateCode` podali sami. Zaprtje bere `i18n` ob vsakem klicu, zato
// sledi zamenjavi jezika. Neznana koda vrne prazen niz in sporočilo zaledja
// ostane nedotaknjeno — vedenje se nikoli ne poslabša.
// T2222: prevajalnik poda tudi interpolacijske parametre iz telesa odgovora
// (`expires_in_hours` → `{{hours}}`), sicer bi sporočilo izpisalo `{{hours}}`.
setDefaultApiErrorTranslator(prevajalnikApiNapakIzI18n(i18n))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

// T2487: podatkovni usmerjevalnik (prej `<BrowserRouter>`), da deluje
// `useBlocker` — varovalo neshranjenih sprememb (`hooks/useLeaveGuard.ts`)
// zadrži tudi klik v stransko/zgornjo vrstico in gumb Nazaj. Najmanjši poseg:
// ena pot `*` izriše obstoječi `<App />` z vsemi njegovimi deklarativnimi
// `<Routes>`, varovali (`ProtectedRoute`, `SysadminRoute`, sedeži), zaklepom
// organizacije, vzdrževanjem in lenim nalaganjem nespremenjeno — kot potomce.
// Ponudniki, ki rabijo usmerjevalnik (`ToastProvider` in vse v `App`), so
// znotraj poti; `QueryClientProvider` ostane zunaj kot doslej.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <ToastProvider>
        <App />
      </ToastProvider>
    ),
  },
])

// T2885: prvi izris počaka na jezik ob zagonu, sicer bi pokazal gole ključe.
// T2899: Sentry se naloži PO prvem izrisu, ob nedejavnosti brskalnika
// (`lib/sentryLazy.ts`, nastavitve v `lib/sentryInit.ts`); napake pred tem
// ujame lovilec iz `lib/sentryEarly.ts` in jih pošlje ob `init`.
function start() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.StrictMode>,
  )
  scheduleSentryStart()
}

// Ob napaki nalaganja prevodov aplikacija vseeno vstane (raje ključi kot prazen zaslon).
void i18nReady.then(start, start)
